var React = require('react');
var createReactClass = require('create-react-class');
var SvgIcon = require('./svg-icon');
var Classable = require('../mixins/classable');
var Colors = require('../utils/colors');

var C42Icon = createReactClass({
    displayName: 'C42Icon',
    mixins: [Classable],

    render: function() {
		var classes = this.getClasses('c42-svg-icon');
		var theIcon = '';

		var icon = this.props.icon;
		var viewBox;

		if(icon == 'action'){
			viewBox = "0 0 20 18";
			theIcon =
				(<g>
					<circle cx="3" cy="9" r="2"/>
					<circle cx="10" cy="9" r="2"/>
					<circle cx="17" cy="9" r="2"/>
				</g>);
		}


		if(icon == 'add'){
			viewBox = "0 0 17 18";
			theIcon =
				(<g>
					<polygon fill="#9B9FA6" points="15,8 9,8 9,2 8,2 8,8 2,8 2,9 8,9 8,15 9,15 9,9 15,9 "/>
				</g>);
		}


		if(icon == 'add-file'){
			viewBox = "0 0 17 24";
			theIcon =
				(<g>
					<path fill="#9B9FA6" d="M11.3,2H1v20h15V5.7L11.3,2z M15,21H2V3h8.9L15,6.2V21z"/>
					<polygon fill="#9B9FA6" points="9,10 8,10 8,12 6,12 6,13 8,13 8,15 9,15 9,13 11,13 11,12 9,12 		"/>
				</g>);
		}


		if(icon == 'add-folder'){
			viewBox = "0 0 23 24";
			theIcon =
				(<g>
					<polygon fill="#9B9FA6" points="12,10 11,10 11,12 9,12 9,13 11,13 11,15 12,15 12,13 14,13 14,12 12,12 		"/>
					<path fill="#9B9FA6" d="M11.4,6l-2-2H0v16h23V6H11.4z M22,19H1V5h8l2,2h11V19z"/>
				</g>);
		}


		if(icon == 'add-person') {
			viewBox = '0 0 23 18';
			theIcon =
				(<g>
					<path fill="#9B9FA6" d="M14,17H1v-0.5C1,13.1,3.6,10,7.5,10s6.5,3.4,6.5,6.5V17z M2,16h11c-0.3-2.6-2.5-5-5.6-5S2.3,13.4,2,16z"/>
					<path fill="#9B9FA6" d="M7.4,9.2c-2.3,0-4.1-1.8-4.1-4.1S5.1,1,7.4,1s4.1,1.8,4.1,4.1S9.7,9.2,7.4,9.2z M7.4,2.1 c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1S9.1,2.1,7.4,2.1z"/>
					<rect x="18" y="1" fill="#9B9FA6" width="1" height="7"/>
					<rect x="15" y="4" fill="#9B9FA6" width="7" height="1"/>
				</g>);
		}

		if(icon == 'alert') {
			viewBox = '0 0 48 48';
			theIcon =
				(<g>
					<path fill="#DE4242" d="M39.5,36L25.5,10.1c-0.8-1.4-2.1-1.4-2.9,0L8.5,36C7.5,37.5,8,39,10,39h28C40.2,39,40.3,37.4,39.5,36z
						M23,17.9c0-0.6,0.4-1,1-1s1,0.4,1,1v9c0,0.6-0.4,1-1,1s-1-0.4-1-1V17.9z M24,34.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2
						S25.1,34.9,24,34.9z"/>
				</g>);
		}

		if(icon == 'back') {
			viewBox = '0 0 18 18';
			theIcon =
				(<g>
					<rect x="5" y="8" fill="#00B2E2" width="9" height="1"/>
					<polygon fill="#00B2E2" points="7.6,12.3 4.3,8.5 7.6,4.7 8.3,5.3 5.7,8.5 8.3,11.7 		"/>
				</g>);
		}

		if(icon == 'calendar'){
			viewBox = "0 0 15 18";
			theIcon =
				(<g>
					<path fill="#585F6B" d="M11,4V2h-1v2H5V2H4v2H1v12h13V4H11z M2,8h3v3H2V8z M9,11H6V8h3V11z M2,15v-3h3v3H2z M6,15v-3h3v3H6z M13,15
						h-3v-3h3V15z M13,11h-3V8h3V11z M2,7V5h11v2H2z"/>
				</g>);
		}


		if(icon == 'caret-right'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="3,13 7,9 3,5 "/>
				</g>);
		}


		if(icon == 'caret-left'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="7,5 3,9 7,13 "/>
				</g>);
		}


		if(icon == 'chevron-down'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="5,12 1,7.7 1.6,7 5,10.6 8.4,7 9,7.7 	"/>
				</g>);
		}


		if(icon == 'chevron-down-small'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="2,7.7 2.6,7 5,9.6 7.4,7 8,7.7 5,11 	"/>
				</g>);
		}


		if(icon == 'chevron-left'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="6.3,13 2,9 6.3,5 7,5.6 3.4,9 7,12.4 	"/>
				</g>);
		}


		if(icon == 'chevron-right'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="3.7,5 8,9 3.7,13 3,12.4 6.6,9 3,5.6 	"/>
				</g>);
		}


		if(icon == 'chevron-right-small'){
			viewBox = "0 0 10 18";
			theIcon =
				(<g>
					<polygon points="3.7,12.2 3,11.6 5.6,9 3,6.4 3.7,5.8 7,9 	"/>
				</g>);
		}


		if(icon == 'close' || icon == 'remove'){
			viewBox = "0 0 18 18";
			theIcon =
				(<g>
					<path fill="#9B9FA6" d="M9,1c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S4.6,1,9,1 M9,0C4,0,0,4,0,9s4,9,9,9s9-4,9-9S14,0,9,0L9,0z"/>
					<rect x="8.5" y="4.8" transform="matrix(0.7071 0.7071 -0.7071 0.7071 9 -3.7279)" fill="#9B9FA6" width="1" height="8.5"/>
					<rect x="4.8" y="8.5" transform="matrix(0.7071 0.7071 -0.7071 0.7071 9 -3.7279)" fill="#9B9FA6" width="8.5" height="1"/>
				</g>);
		}


		if(icon == 'close-modal'){
			viewBox = "0 0 12 18";
			theIcon =
				(<g>
					<polygon fill="#9B9FA6" points="10.4,5.4 9.6,4.6 6,8.3 2.4,4.6 1.6,5.4 5.3,9 1.6,12.6 2.4,13.4 6,9.7 9.6,13.4 10.4,12.6 6.7,9
						"/>
				</g>);
		}


		if(icon == 'cloud-exclusion'){
			viewBox = "0 0 20 18";
			theIcon =
				(<g>
					<path d="M10,4c2.8,0,5,2.2,5,5v1h1c1.1,0,2,0.9,2,2s-0.9,2-2,2H5c-1.7,0-3-1.3-3-3c0-1.5,1-2.7,2.5-2.9L5.1,8
						l0.2-0.6C6,5.4,7.9,4,10,4 M10,3C7.4,3,5.1,4.7,4.3,7.1C2.4,7.4,1,9,1,11c0,2.2,1.8,4,4,4h11c1.7,0,3-1.3,3-3s-1.3-3-3-3
						C16,5.7,13.3,3,10,3L10,3z"/>
					<rect x="9" y="5.5" transform="matrix(0.7071 0.7071 -0.7071 0.7071 9.1464 -4.0815)" width="1" height="7.1"/>
				</g>);
		}


		if(icon == 'deleted'){
			viewBox = "0 0 14 18";
			theIcon =
				(<g>
					<path d="M13,4h-3c0,0,0,0,0-1S9,2,9,2S6,2,5,2S4,3,4,3v1H1v1h1c0,2.2,0,9.2,0,10c0,1,1,1,1,1s7,0,8,0s1-1,1-1V5h1V4
						z M5,3h4v1H5V3z M11,15C11,15,11,15,11,15l-8,0c0,0,0,0,0,0V5h8L11,15z"/>
					<rect x="5" y="7" width="1" height="6"/>
					<rect x="8" y="7" width="1" height="6"/>
				</g>);
		}


		if(icon == 'draggable'){
			viewBox = "0 0 2 18";
			theIcon =
				(<g>
					<circle cx="1" cy="5" r="1"/>
					<circle cx="1" cy="9" r="1"/>
					<circle cx="1" cy="13" r="1"/>
				</g>);
		}


		if(icon == 'edit'){
			viewBox = "0 0 12 18";
			theIcon =
				(<g>
					<rect x="8.8" y="4.1" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 20.1066 2.6716)" width="1.4" height="2.8"/>
					<polygon points="1,12 7,6 9,8 3,14 1,14 		"/>
				</g>);
		}


		if(icon == 'favorite' || icon == 'star'){
			viewBox = "0 0 19 18";
			theIcon=
				(<g>
					<path d="M9.5,14.1l5.4,3.2l-1.4-6.1l4.7-4.1l-6.2-0.5L9.5,0.8L7.1,6.6L0.8,7.1l4.7,4.1l-1.4,6.1L9.5,14.1z"/>
				</g>);
		}


		if(icon == 'file-exclusion'){
			viewBox = "0 0 16 18";
			theIcon =
				(<g>
					<path d="M8,3c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,3,8,3 M8,2C4.1,2,1,5.1,1,9s3.1,7,7,7s7-3.1,7-7
						S11.9,2,8,2L8,2z"/>
					<rect x="7.5" y="5.5" transform="matrix(0.7071 0.7071 -0.7071 0.7071 8.7071 -3.0208)" width="1" height="7.1"/>
				</g>);
		}


		if(icon == 'folder'){
			viewBox = "0 0 23 18";
			theIcon =
				(<g>
					<polygon points="2,15 21,15 21,5 12.4,5 10.7,3 2,3 "/>
				</g>);
		}


		if(icon == 'folder-empty'){
			viewBox = "0 0 23 18";
			theIcon =

				(<g>
					<path d="M22,17H1V1h11.6l1.7,2H22V17z M2,16h19V4h-7.3L12,2H2V16z"/>
				</g>);
		}


		if(icon == 'folder-outlined') {
			viewBox = "0 0 18 18";
			theIcon =
				(<g>
					<path fill={Colors.primaryBlue} d="M9.4,5l-2-2H0v12h18V5H9.4z M17,14H1V4h6l2,2h8V14z"/>
				</g>);
		}


		if(icon == 'gear'){
			viewBox = "0 0 18 18";
			theIcon =
				(<g>
					<path d="M9.9,1l0.5,1.9c0.7,0.2,1.4,0.4,1.9,0.8l1.7-1L15.3,4l-1,1.7c0.4,0.6,0.6,1.2,0.8,1.9L17,8.1v1.8
						l-1.9,0.5c-0.2,0.7-0.4,1.4-0.8,1.9l1,1.7L14,15.3l-1.7-1c-0.6,0.4-1.2,0.6-1.9,0.8L9.9,17H8.1l-0.5-1.9
						c-0.7-0.2-1.4-0.4-1.9-0.8l-1.7,1L2.7,14l1-1.7c-0.4-0.6-0.6-1.2-0.8-1.9L1,9.9V8.1l1.9-0.5c0.2-0.7,0.4-1.4,0.8-1.9L2.7,4L4,2.7
						l1.7,1c0.6-0.4,1.2-0.6,1.9-0.8L8.1,1H9.9 M10.7,0H9.9H8.1H7.3L7.1,0.8L6.8,2.1C6.4,2.2,6.1,2.4,5.7,2.6L4.5,1.9L3.8,1.5L3.3,2
						L2,3.3L1.5,3.8l0.4,0.7l0.7,1.2C2.4,6.1,2.2,6.4,2.1,6.8L0.8,7.1L0,7.3v0.8v1.8v0.8l0.8,0.2l1.4,0.3c0.1,0.4,0.3,0.7,0.5,1.1
						l-0.7,1.2l-0.4,0.7L2,14.7L3.3,16l0.6,0.6l0.7-0.4l1.2-0.7c0.4,0.2,0.7,0.3,1.1,0.5l0.3,1.4L7.3,18h0.8h1.8h0.8l0.2-0.8l0.3-1.4
						c0.4-0.1,0.7-0.3,1.1-0.5l1.2,0.7l0.7,0.4l0.6-0.6l1.3-1.3l0.6-0.6l-0.4-0.7l-0.7-1.2c0.2-0.4,0.3-0.7,0.5-1.1l1.4-0.3l0.8-0.2
						V9.9V8.1V7.3l-0.8-0.2l-1.4-0.3c-0.1-0.4-0.3-0.7-0.5-1.1l0.7-1.2l0.4-0.7L16,3.3L14.7,2l-0.6-0.6l-0.7,0.4l-1.2,0.7
						c-0.4-0.2-0.7-0.3-1.1-0.5l-0.3-1.4L10.7,0L10.7,0z"/>
					<path d="M9,6.4c1.4,0,2.6,1.1,2.6,2.6s-1.1,2.6-2.6,2.6S6.4,10.4,6.4,9S7.6,6.4,9,6.4 M9,5.4C7,5.4,5.4,7,5.4,9
						S7,12.6,9,12.6S12.6,11,12.6,9S11,5.4,9,5.4L9,5.4z"/>
				</g>);
		}


		if(icon == 'home'){
			viewBox = "0 0 18 18";
			theIcon =
				(<g>
					<path d="M14,8.7l1.6,1.6l0.7-0.7L9,2.3L1.6,9.6l0.7,0.7L4,8.7V15h10V8.7z M5,14V7.7l4-4l4,4V14H5z"/>
				</g>);
		}


		if(icon == 'info') {
			viewBox = "0 0 17 18";
			theIcon =
				(<g>
					<path fill={Colors.primaryBlue} d="M8.5,2C12.6,2,16,5.4,16,9.5S12.6,17,8.5,17S1,13.6,1,9.5S4.4,2,8.5,2 M8.5,1C3.8,1,0,4.8,0,9.5
						S3.8,18,8.5,18S17,14.2,17,9.5S13.2,1,8.5,1L8.5,1z"/>
					<circle fill="#01B3E3" cx="8.5" cy="5.5" r="1"/>

					<rect x="8" y="8" fill="#01B3E3" width="1" height="7"/>
				</g>);
		}


		if(icon == 'link'){
			viewBox = "0 0 18 16";
			theIcon =
				(<g>
					<path d="M8.1,11.3l-2.4,2.4c-0.8,0.8-2.1,0.8-2.9,0
						C2,13,2,11.7,2.8,10.9l3.4-3.4c0.8-0.8,2.1-0.8,2.9,0c0.3,0.3,0.5,0.7,0.6,1.1c0,0,0,0,0,0L10.3,8C10.2,7.6,10,7.2,9.7,6.9
						c-1.1-1.1-2.9-1.1-4,0l-3.4,3.4c-1.1,1.1-1.1,2.9,0,4c1.1,1.1,2.9,1.1,4,0l3-3C8.8,11.4,8.5,11.4,8.1,11.3"/>
					<path d="M14.2,2.4c-1.1-1.1-2.9-1.1-4,0l-3,3c0.4,0,0.7,0,1.1,0
						l2.4-2.4c0.8-0.8,2.1-0.8,2.9,0c0.8,0.8,0.8,2.1,0,2.9l-3.4,3.4C9.5,10,8.2,10,7.4,9.2C7.1,8.9,6.9,8.5,6.8,8.1c0,0,0,0,0,0
						L6.2,8.7c0.1,0.4,0.4,0.7,0.7,1.1c1.1,1.1,2.9,1.1,4,0l3.4-3.4C15.4,5.2,15.4,3.5,14.2,2.4"/>
				</g>);
		}


		if(icon == 'link-options'){
			viewBox = "0 0 22 24";
			theIcon =
				(<g>
					<path fill={Colors.primaryBlue} d="M9.3,15.2l-3,3c-1,1-2.6,1-3.6,0c-1-1-1-2.6,0-3.6L7,10.4
						c1-1,2.6-1,3.6,0c0.4,0.4,0.6,0.9,0.7,1.4c0,0,0,0,0,0l0.8-0.8c-0.2-0.5-0.4-0.9-0.8-1.3c-1.4-1.4-3.6-1.4-5,0L2,14
						c-1.4,1.4-1.4,3.6,0,5c1.4,1.4,3.6,1.4,5,0l3.7-3.7C10.2,15.3,9.8,15.3,9.3,15.2"/>
					<path fill={Colors.primaryBlue} d="M17,4c-1.4-1.4-3.6-1.4-5,0L8.3,7.7c0.5,0,0.9,0,1.4,0.1l3-3
						c1-1,2.6-1,3.6,0c1,1,1,2.6,0,3.6L12,12.6c-1,1-2.6,1-3.6,0c-0.4-0.4-0.6-0.9-0.7-1.4c0,0,0,0,0,0L6.9,12c0.2,0.5,0.4,0.9,0.8,1.3
						c1.4,1.4,3.6,1.4,5,0L17,9C18.3,7.6,18.3,5.4,17,4"/>
					<polygon fill={Colors.primaryBlue} points="14,16.7 14.6,16 17,18.6 19.4,16 20,16.7 17,20 	"/>
				</g>);
		}


		if(icon == 'locked'){
			viewBox = "0 0 12 18";
			theIcon =
				(<g>
					<path d="M10,8v6H2V8H10 M10,7H2C1.4,7,1,7.4,1,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1V8C11,7.4,10.6,7,10,7L10,7z"/>
					<path d="M6,3C4.3,3,3,4.3,3,6v2h1V6c0-1.1,0.9-2,2-2s2,0.9,2,2v2h1V6C9,4.3,7.7,3,6,3z"/>
				</g>);
		}


		if(icon == 'make-current') {
			viewBox = "0 0 21 24";
			theIcon =
				(<g>
					<polygon fill={Colors.primaryBlue} points="17,6 15,6 15,4.6 12,1 1,1 1,17 13.1,17 11.3,19.1 12,19.7 15,16.3 12,13 11.3,13.7 13.4,16 2,16
						2,2 11.4,2 14,5.1 14,6 6,6 6,14 7,14 7,7 14,7 15,7 16.4,7 19,10 19,22 7,22 7,19 6,19 6,23 20,23 20,9.6 	"/>
				</g>);
		}


		if(icon == 'maximize') {
			viewBox = "0 0 15 18";
			theIcon =
				(<g>
					<path d="M1,3v13h13V3H1z M13,15H2V7h11V15z"/>
				</g>);
		}


		if(icon == 'minimize'){
			viewBox = "0 0 15 18";
			theIcon =
				(<g>
					<rect x="1" y="8" fill="#585F6B" width="13" height="1"/>
				</g>);
		}


		if(icon == 'missing') {
			viewBox = "0 0 18 18";
			theIcon =
				(<g>
					<path fill={Colors.softerText} d="M9,3c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S5.7,3,9,3 M9,2C5.1,2,2,5.1,2,9c0,3.9,3.1,7,7,7
						c3.9,0,7-3.1,7-7C16,5.1,12.9,2,9,2L9,2z"/>
					<polygon fill={Colors.softerText} points="9.9,10.6 7.9,8.6 5.3,10.4 4.7,9.6 8.1,7.4 10.1,9.4 12.7,7.6 13.3,8.4 		"/>
				</g>);
		}


		if(icon == 'pause'){
			viewBox = "0 0 14 18";
			theIcon=
				(<g>
					<path d="M12,4v10H2V4H12 M12,3H2C1.4,3,1,3.4,1,4v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3
						L12,3z"/>
					<rect x="5" y="6" width="1" height="6"/>
					<rect x="8" y="6" width="1" height="6"/>
				</g>);
		}


		if(icon == 'play'){
			viewBox = "0 0 14 18";
			theIcon=
				(<g>
					<path d="M12,4v10H2V4H12 M12,3H2C1.4,3,1,3.4,1,4v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V4C13,3.4,12.6,3,12,3
						L12,3z"/>
					<polygon points="5,12 5,6 9,9"/>
				</g>);
		}


		if(icon == 'preview'){
			viewBox = "0 0 22 18";
			theIcon =
				(<g>
					<path d="M11,4c4.6,0,7.8,3.6,8.8,5c-1,1.4-4.1,5-8.8,5c-4.6,0-7.8-3.6-8.8-5C3.2,7.6,6.4,4,11,4 M11,3
						C4.6,3,1,9,1,9s3.6,6,10,6s10-6,10-6S17.4,3,11,3L11,3z"/>
					<circle cx="11" cy="9" r="2"/>
				</g>);
		}


		if(icon == 'restore'){
			viewBox = "0 0 17 18";
			theIcon =
				(<g>
					<rect x="3" y="14" fill="#00B2E2" width="11" height="1"/>
					<polygon fill="#00B2E2" points="11.7,9 9,11.3 9,3 8,3 8,11.3 5.3,9 4.7,9.8 8.5,13 12.3,9.8 	"/>
				</g>);
		}


		if(icon == 'search'){
			viewBox = "0 0 14 18";
			theIcon=

				(<g>
					<path d="M13.4,14.6l-3.5-3.5C10.6,10.3,11,9.2,11,8c0-2.8-2.2-5-5-5S1,5.2,1,8s2.2,5,5,5c1.2,0,2.3-0.4,3.1-1.1
						l3.5,3.5L13.4,14.6z M2,8c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C3.8,12,2,10.2,2,8z"/>
				</g>);
		}


		if(icon == 'sort-down'){
			viewBox = "0 0 10 18";
			theIcon=
				(<g>
					<polygon  points="1,7 5,11 9,7 "/>
				</g>);
		}


		if(icon == 'sort-up'){
			viewBox = "0 0 10 18";
			theIcon=
				(<g>
					<polygon points="9,11 5,7 1,11 "/>
				</g>);
		}


		if(icon == 'undelete'){
			viewBox = "0 0 22 24";
			theIcon =
				(<g>
					<path fill="#9B9FA6" d="M16,4h-3V3c0-0.6-0.4-1.1-1-1H5C4.4,1.9,4,2.4,4,3v1H1v1h1v14c0,0.7,0.4,1,1,1h7l-0.1-1H3.1
						C3,19,3,19,3,18.9V5h11v4.2h1V5h1V4z M5,3C5,2.9,5.1,3,5,3h6.9C12,3,12,3,12,3v1H5L5,3z"/>
					<polygon fill="#9B9FA6" points="10,7 11,7 11,10.6 10,12 			"/>
					<line fill="none" x1="6" y1="7" x2="6" y2="16"/>
					<rect x="6" y="7" fill="#9B9FA6" width="1" height="9"/>
					<path fill="#9B9FA6" d="M14.5,9c-3.6,0-6.4,2.9-6.4,6.5s2.7,6.5,6.4,6.5s6.5-2.9,6.5-6.5C21,11.9,18.1,9,14.5,9z M14.6,21
						c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5s5.5,2.4,5.5,5.5C20,18.5,17.6,21,14.6,21z"/>
					<polygon fill="#9B9FA6" points="15.9,13.4 14.5,14.8 13.1,13.4 12.4,14.1 13.8,15.5 12.4,16.9 13.1,17.6 14.5,16.2 15.9,17.6
						16.6,16.9 15.2,15.5 16.6,14.1 		"/>
				</g>);
		}


		if(icon == 'versions'){
			viewBox = "0 0 16 18";
			theIcon =
				(<g>
					<path d="M8,3c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,3,8,3 M8,2C4.1,2,1,5.1,1,9s3.1,7,7,7s7-3.1,7-7
						S11.9,2,8,2L8,2z"/>
					<polygon points="11,10 7,10 7,5 8,5 8,9 11,9"/>
				</g>);
		}


		if(icon == 'view-deleted'){
			viewBox = "0 0 23 24";
			theIcon =
				(<g>
					<path fill="#9B9FA6" d="M20,11c0,0,0-0.1,0-1c0-0.7-0.9-1-0.9-1S17.5,9,16,9V5l-4-4H1v20h10c0,0.5,0,0.9,0,1c0,0.5,0.5,1,1,1
						c0,0,7.1,0,8,0c0.4,0,1-0.5,1-1c0-2.3,0-10,0-10h1v-1H20z M19,10v1h-6v-1H19z M2,20V2h9.6L15,5.5V9c-0.9,0-1.8,0-2.1,0
						c-0.7,0-0.9,1-0.9,1v1h-2v1h1c0,1.4,0,5.5,0,8H2z M20,22h-8c0-0.1,0-10,0-10h8C20,12,20,20.7,20,22z"/>
					<rect x="17" y="14" fill="#9B9FA6" width="1" height="6"/>
					<rect x="14" y="14" fill="#9B9FA6" width="1" height="6"/>
				</g>);
		}


		var getFontSize = function() {
			var str = viewBox,
				arr = str.split(' '),
				fontSize = arr.pop();
			return `${fontSize}px`;
		};

		var style = {
			fontSize:  getFontSize(),
			maxHeight: '1em',
			...this.props.style,
		};

		return (
			<SvgIcon {...this.props} viewBox={viewBox} className={classes} style={style}>
				{theIcon}
			</SvgIcon>
		);
	},
});

module.exports = C42Icon;
